import styled from "styled-components";

export const GameContainerStyled = styled.div`
  padding: 20px 18px 40px 18px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .game_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .header_sec {
      padding: 0 16px;
      display: flex;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 40px 18px 104px 18px;
    .breadcrumb_layout {
      display: none;
    }
  }
`;
